import { isEmpty } from 'lodash';

/**
 * Filter users based on union status
 * This filter excludes "Non-Union" users when the switch is on
 * When the switch is off, it has no effect (all users pass)
 * 
 * @param {Boolean} unionStatusFilterOn - Whether the union status filter is on
 * @returns {Function} A filter function that returns true for users that should be included
 */
export const filterUserWithUnionStatus = (unionStatusFilterOn) => {
  // If the filter is off, let all users through
  if (!unionStatusFilterOn) {
    return () => true;
  }

  return (user) => {
    // If user doesn't have unionStatus data, we'll let them through
    if (!user || typeof user.unionStatus === 'undefined') {
      return true;
    }

    // Exclude users with "Non-Union" status when filter is on
    return user.unionStatus !== "Non-Union";
  };
};

export default filterUserWithUnionStatus;
